import {Tracedo} from "../../entities/Tracedo";
import {TracedoFactory} from "./TracedoFactory";
import {Checkpoint} from "../../entities/Checkpoint";
import {CheckpointFactory} from "./CheckpointFactory";
import {PoItem} from "../../entities/PoItem";
import {PoItemsFactory} from "./PoItemsFactory";
import {TracedoParentInfo} from "../../entities/TracedoParentInfo";

export class TracedoBuilder {
    tracedo: Tracedo;

    constructor(tracedo: Tracedo = TracedoFactory.makeEmptyTracedo()) {
        this.tracedo = tracedo;
    }

    public setupWithSubject(subjectId: number): this {
        this.tracedo.myField ='spediter';
        this.tracedo.mySubjectId=subjectId;
        this.tracedo.customerPartnerId=subjectId;
        this.tracedo.supplierPartnerId=subjectId;

        return this;
    }

    public setOrigin(checkpoint: Checkpoint): this {
        this.tracedo.pickupAddressId = checkpoint.addressbookId;
        this.tracedo.originAddressCity = checkpoint.addressTown;
        this.tracedo.originAddressCountryId = checkpoint.addressCountryId;
        this.tracedo.originAddressName = checkpoint.addressName;
        this.tracedo.originAddressStreet = checkpoint.addressStreet;
        this.tracedo.originAddressStreet2 = checkpoint.addressStreet2;
        this.tracedo.originAddressZipCode = checkpoint.addressZipCode;

       return this;
    }

    public setOriginDates(checkpoint: Checkpoint): this {
        this.tracedo.etdFrom = checkpoint.etdFrom ? checkpoint.etdFrom : checkpoint.etd;
        this.tracedo.etdTo = checkpoint.etdTo ? checkpoint.etdTo : checkpoint.etd;

        return this;
    }

    public setOriginParent(originParentId?: number, originParentType?: string): this {
        this.tracedo.originParentId = originParentId;
        this.tracedo.originParentType = originParentType;
        return this;
    }

    public setDestinationParent(destinationParentId?: number, destinationParentType?: string): this {
        this.tracedo.destinationParentId = destinationParentId;
        this.tracedo.destinationParentType = destinationParentType;
        return this;
    }

    public setDestination(checkpoint: Checkpoint): this {
        this.tracedo.deliveryAddressId = checkpoint.addressbookId;
        this.tracedo.destAddressCity = checkpoint.addressTown;
        this.tracedo.destAddressCountryId = checkpoint.addressCountryId;
        this.tracedo.destAddressName = checkpoint.addressName;
        this.tracedo.destAddressStreet = checkpoint.addressStreet;
        this.tracedo.destAddressStreet2 = checkpoint.addressStreet2;
        this.tracedo.destAddressZipCode = checkpoint.addressZipCode;

       return this;
    }

    public setDestinationDates(checkpoint: Checkpoint): this {
        this.tracedo.etaFrom = checkpoint.etaFrom ? checkpoint.etaFrom : checkpoint.eta;
        this.tracedo.etaTo = checkpoint.etaTo ? checkpoint.etaTo : checkpoint.eta;

        return this;
    }

    public setParent(tracedoId: number, tracedoParentInfo: TracedoParentInfo): this {
        this.tracedo.parentId = tracedoId;
        this.tracedo.parentNumber = tracedoParentInfo.parentNumber;

        console.log("tracedo parent info: ", tracedoParentInfo);
        return this.setOriginParent(tracedoParentInfo.startCheckpointId, tracedoParentInfo.startCheckpointType)
            .setDestinationParent(tracedoParentInfo.endCheckpointId, tracedoParentInfo.endCheckpointType)
            .setCheckpointsParent()
            .eraseCheckpointsIds();
    }

    public setCheckpointsExcludingStartAndEnd(checkpoints: Checkpoint[], startCheckpoint: Checkpoint, endCheckpoint: Checkpoint): this {
        let startReached = false;
        for (let checkpoint of checkpoints) {
            if (!startReached) {
                if (checkpoint.id === startCheckpoint.id) {
                    startReached = true;
                }
                continue;
            }
            if (checkpoint.id === endCheckpoint.id) { break; }

            this.tracedo.checkpoints.push({ ...checkpoint });
        }
        return this;
    }

    public setCheckpointsParent(): this {
        this.tracedo.checkpoints.forEach((checkpoint: Checkpoint) => {
            checkpoint.parentId = checkpoint.id;
        })
        return this;
    }

    public eraseCheckpointsIds(): this {
        this.tracedo.checkpoints.forEach((checkpoint: Checkpoint) => {
            checkpoint.id = null;
        });
        return this;
    }

    public setCargoDetails(tracedo: Tracedo): this {
        this.tracedo.chargeableVolume = tracedo.chargeableVolume;
        this.tracedo.colli = tracedo.colli;
        this.tracedo.kgs = tracedo.kgs;
        this.tracedo.cbm = tracedo.cbm;
        this.tracedo.adr = tracedo.adr;
        this.tracedo.adrClass = tracedo.adrClass;
        this.tracedo.un = tracedo.un;
        this.tracedo.packingGroup = tracedo.packingGroup;

        return this;
    }

    public setCheckpoints(checkpoints: Checkpoint[]): this {

        for (let checkpoint of checkpoints) {
            const newCheckpoint = { ...checkpoint };
            newCheckpoint.etd = null;
            newCheckpoint.eta = null;
            newCheckpoint.ata = null;
            newCheckpoint.atd = null;
            this.tracedo.checkpoints.push(newCheckpoint);
        }
        return this;
    }

    public setPoItems(poItems: PoItem[]): this {
        this.tracedo.poItems = [];
        for (let poItem of poItems) {
            const item = PoItemsFactory.makeCopy(poItem);
            item.createdTimestamp = null;
            item.ecrTimestamp = null;
            item.createdUser = null;
            item.createdUserId = null;
            item.tracedo = null;
            item.tracedoId = null;

            item.pn1 = '';
            item.pn2 = '';
            item.pn3 = '';

            this.tracedo.poItems.push(item);
        }

        return this;
    }

    public prefillDuplicateFrom(tracedo: Tracedo): this {
        this.tracedo.customerPartnerId = tracedo.customerPartnerId;
        this.tracedo.myPicUserId = tracedo.myPicUserId;
        this.tracedo.supplierPartnerId = tracedo.supplierPartnerId;
        this.tracedo.kindId = tracedo.kindId;
        this.tracedo.roadTypeId = tracedo.roadTypeId;

        this.setOrigin(CheckpointFactory.makeOriginCheckpoint(tracedo, null));
        this.tracedo.pickupContactId = tracedo.pickupContactId;
        this.tracedo.originContactEmail = tracedo.originContactEmail;
        this.tracedo.originContactFirstName = tracedo.originContactFirstName;
        this.tracedo.originContactLastName = tracedo.originContactLastName;
        this.tracedo.originContactPhone = tracedo.originContactPhone;

        this.setDestination(CheckpointFactory.makeDestinationCheckpoint(tracedo, null));
        this.tracedo.deliveryContactId = tracedo.deliveryContactId;
        this.tracedo.destinationContactEmail = tracedo.destinationContactEmail;
        this.tracedo.destinationContactFirstName = tracedo.destinationContactFirstName;
        this.tracedo.destinationContactLastName = tracedo.destinationContactLastName;
        this.tracedo.destinationContactPhone = tracedo.destinationContactPhone;

        this.tracedo.bdpCntrTypeId = tracedo.bdpCntrTypeId;
        this.tracedo.rejdar = tracedo.rejdar;
        this.tracedo.custom = tracedo.custom;
        this.tracedo.customOffice = tracedo.customOffice;
        this.tracedo.shipperName = tracedo.shipperName;
        this.tracedo.consigneeName = tracedo.consigneeName;
        this.tracedo.depotId = tracedo.depotId;
        this.tracedo.trainNr = tracedo.trainNr;

        this.tracedo.originRampId = tracedo.originRampId;
        this.tracedo.originRampName = tracedo.originRampName;
        this.tracedo.destinationRampId = tracedo.destinationRampId;
        this.tracedo.destinationRampName = tracedo.destinationRampName;
        this.tracedo.cancelRequest = null;

        if (tracedo.originRamp) {
            this.tracedo.originRamp = tracedo.originRamp;
        }
        if (tracedo.originRamp) {
            this.tracedo.destinationRamp = tracedo.destinationRamp;
        }

        if (tracedo.checkpoints) {
            this.setCheckpoints(tracedo.checkpoints.filter((checkpoint: Checkpoint): boolean => checkpoint.typeId !== null))
                .eraseCheckpointsIds();
        }

        if (tracedo.fields) {
            this.tracedo.fields = tracedo.fields;
        }

        return this;
    }

    public formatDates(): this {
        this.tracedo.etdFrom = this.tracedo.etdFrom === null ? null : kendo.parseDate(this.tracedo.etdFrom as string);
        this.tracedo.etdTo = this.tracedo.etdTo === null ? null : kendo.parseDate(this.tracedo.etdTo as string);
        this.tracedo.etaFrom = this.tracedo.etaFrom === null ? null : kendo.parseDate(this.tracedo.etaFrom as string);
        this.tracedo.etaTo = this.tracedo.etaTo === null ? null : kendo.parseDate(this.tracedo.etaTo as string);
        this.tracedo.atd = this.tracedo.atd === null ? null : kendo.parseDate(this.tracedo.atd as string);
        this.tracedo.atdReady = this.tracedo.atdReady === null ? null : kendo.parseDate(this.tracedo.atdReady as string);
        this.tracedo.ata = this.tracedo.ata === null ? null : kendo.parseDate(this.tracedo.ata as string);
        this.tracedo.ataReady = this.tracedo.ataReady === null ? null : kendo.parseDate(this.tracedo.ataReady as string);

        this.tracedo.myUzp = this.tracedo.myUzp === null ? null : kendo.parseDate(this.tracedo.myUzp as string);
        this.tracedo.supplierPartnerUzp = this.tracedo.supplierPartnerUzp === null ? null : kendo.parseDate(this.tracedo.supplierPartnerUzp as string);

        if (this.tracedo.checkpoints) {
            this.tracedo.checkpoints.forEach((checkpoint: Checkpoint) => {
                checkpoint.eta = checkpoint.eta === null ? null : kendo.parseDate(checkpoint.eta as string);
                checkpoint.etd = checkpoint.etd === null ? null : kendo.parseDate(checkpoint.etd as string);
                checkpoint.ata = checkpoint.ata === null ? null : kendo.parseDate(checkpoint.ata as string);
                checkpoint.atd = checkpoint.atd === null ? null : kendo.parseDate(checkpoint.atd as string);
            });
        } else {
            this.tracedo.checkpoints = [];
        }

        this.tracedo.ecrFrom = this.tracedo.ecrFrom === null ? null : kendo.parseDate(this.tracedo.ecrFrom as string);
        this.tracedo.ecrTo = this.tracedo.ecrTo === null ? null : kendo.parseDate(this.tracedo.ecrTo as string);
        this.tracedo.rdlFrom = this.tracedo.rdlFrom === null ? null : kendo.parseDate(this.tracedo.rdlFrom as string);
        this.tracedo.rdlTo = this.tracedo.rdlTo === null ? null : kendo.parseDate(this.tracedo.rdlTo as string);

        return this;
    }

    public setupRamps(): this {
        if (this.tracedo.originRamp === null) {
            this.tracedo.originRamp = {"id": null, "name": null};
        }
        if (this.tracedo.destinationRamp === null) {
            this.tracedo.destinationRamp = {"id": null, "name": null};
        }
        if (this.tracedo.checkpoints) {
            for (let checkpoint of this.tracedo.checkpoints) {
                if (checkpoint.ramp === null) {
                    checkpoint.ramp = {"id": null, "name": null};
                }
                if (!checkpoint.rampId) {
                    checkpoint.rampId = null;
                }
            }
        }
        return this;
    }

    public getTracedo(): Tracedo {
        return this.tracedo;
    }
}